class McBtn extends McBase {
    
    actions = {
        open: () => { this.target.open() },
        close: () => { this.target.close() },
        toggle: () => { 
            if(this.internals.states.has('open') || this.internals.states.has('--open')){ 
                this.target.close();
                this.close();
            }
            else{
                this.target.open();
            }
        },
    }
    after = {
        resetForm: () => {
            const inputs = this.target.querySelectorAll('input');
            const textarea = this.target.querySelector('textarea');
            textarea.value = '';
            inputs.forEach(input => {input.value = ''; input.checked = false});
            document.querySelector(this.dataset.label).classList.remove('show');
        },
        showLabel: () => {
            document.querySelector(this.dataset.label).classList.add('show')
        }
    }
    constructor(){
        super();
    }
    connectedCallback(){
        this.target = document.querySelector(this.dataset.target);
        this.addEventListener( 'click' , () => {
            this.actions[this.dataset.action]();
            if(this.dataset.after){
                this.after[this.dataset.after]();
            }
        })
    }

}

if(!window.customElements.get('mc-btn')){
    window.customElements.define('mc-btn', McBtn);
}
window.McBtn = McBtn;